module.exports = __webpack_public_path__ + "img/wornOutTools.3529ee89.png";